<mat-sidenav-container
  id="side-nav-container"
  [ngClass]="{
    'sidebar-collapsed': isSidebarCollapsed$ | async,
    mobile: mobile,
    'nav-expanded': navExpanded(),
  }"
  (backdropClick)="collapseNav()"
  (swipeleft)="collapseNav()"
  >
  @if (!useBusinessNav) {
    <mat-sidenav
      opened
      [mode]="mobile ? 'over' : 'side'"
      position="start"
      class="sidenav-menu"
    [ngClass]="{
      expanded: navExpanded(),
      mobile: mobile,
      'over-content': navExpanded() && !navSetExpanded,
    }"
      [disableClose]="true"
      (mouseover)="navSetExpanded ? null : (navViewExpanded = disableMouseOver ? navSetExpanded : true)"
      (mouseleave)="navSetExpanded ? null : (navViewExpanded = false)"
      [fixedTopGap]="mobile ? topGap + 8 : topGap"
      fixedInViewport
      #sidenavMenu
      >
      <div class="title-section" [ngClass]="{ collapsed: !navExpanded(), mobile: mobile }">
        @if (logoUrl) {
          <img [src]="logoUrl" class="logo" />
        }
        <div class="app-info">
          <div class="app-name">{{ appName }}</div>
        </div>
      </div>
      @if (showGetUpgrade) {
        <div class="upgrade-section" [ngClass]="{ collapsed: !navExpanded() }">
          @if (navExpanded()) {
            <div class="upgrade-info">
              {{ upgradeText | translate }}
            </div>
          }
          <div
            class="sidebar-upgrade-action-button"
            (click)="sidebarUpgradeAction()"
            [ngClass]="{ collapsed: !navExpanded() }"
            >
            <div class="sidebar-upgrade-action-button-text" [ngClass]="{ collapsed: !navExpanded() }">
              {{ upgradeButtonText | translate }}
            </div>
          </div>
        </div>
      }
      <div class="nav-items">
        @if (sidebarPrimaryActionButton) {
          <div
            class="sidebar-primary-action-button"
            (click)="sidebarPrimaryAction()"
            [ngClass]="{ collapsed: !navExpanded() }"
            >
            <mat-icon>{{ sidebarPrimaryActionIcon }}</mat-icon>
            @if (navExpanded()) {
              <div class="sidebar-primary-action-button-text">
                {{ sidebarPrimaryActionButton | translate }}
              </div>
            }
          </div>
        }
        @for (navItem of navItemsState; track navItem) {
          <va-product-nav-item
            [navItem]="navItem"
            [navExpanded]="navViewExpanded"
            [badgeId]="navItem.badgeId"
            [upgradeChipText]="upgradeChipText | translate"
            (navItemClicked)="navItemClicked.emit($event)"
            />
        }
      </div>
      <div class="nav-custom-side-content">
        <ng-content select="va-product-nav-custom-side-content" />
      </div>
      <div class="nav-footer" [ngClass]="{ collapsed: !navExpanded(), mobile: mobile }">
        @if (navViewExpanded) {
          <div class="nav-branding">
            @if (brandLogoUrl) {
              <img class="nav-brand-logo" [src]="brandLogoUrl" />
            }
            @if (cobrandingLogoUrl) {
              <div class="cobranding">
                <span class="cobranding-text">
                  {{ 'COMMON.POWERED_BY' | translate }}
                </span>
                <img class="cobranding-logo" [src]="cobrandingLogoUrl" />
              </div>
            } @else {
              @if (slogan) {
                <div class="slogan" [innerHTML]="slogan"></div>
              }
            }
          </div>
        }
        <div class="nav-footer-row">
          @if (!mobile) {
            <div class="toggle-nav">
              <button
                mat-icon-button
                class="menu-icon"
                (click)="toggleNavExpanded()"
                [ngClass]="{ flipped: !navSetExpanded }"
                >
                <mat-icon>arrow_back</mat-icon>
              </button>
            </div>
          }
          @if (currentLang$ | async; as currentLang) {
            <div
              class="language-selector"
              [ngClass]="{ hidden: !navExpanded() }"
              >
              <button mat-button [matMenuTriggerFor]="languageOptions">
                <mat-icon>language</mat-icon>
                {{ currentLang | uppercase }}
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
              </button>
              <mat-menu #languageOptions="matMenu" class="language-selector-options">
                @for (language of supportedLangs; track language) {
                  <span mat-menu-item (click)="onLangSelection(language.locale)">
                    @if (!language.flag) {
                      <i class="material-icons language-selector-options__icon">language</i>
                    }
                    @if (language.flag) {
                      <span class="language-selector-options__flag">
                        {{ language.flag }}
                      </span>
                    }
                    <span class="language-selector-options__display">
                      {{ language.display }}
                    </span>
                  </span>
                }
              </mat-menu>
            </div>
          }
        </div>
      </div>
    </mat-sidenav>
  }
  <mat-sidenav-content
    [ngClass]="{
      'with-business-nav': useBusinessNav,
      'with-top-nav': topNavEnabled,
      'nav-expanded': !useBusinessNav && navExpanded() && navSetExpanded && !mobile,
      mobile: mobile,
      'sidebar-expanded': sidebar.opened,
    }"
    >
    @if (!hideToolbar) {
      <mat-toolbar>
        <div class="va-product-nav-toolbar-title">
          @if (mobile && !useBusinessNav) {
            <button mat-icon-button (click)="toggleNavExpanded()">
              <mat-icon>menu</mat-icon>
            </button>
          }
          <div class="toolbar-text">
            <div>
              @if ((breadcrumbs$ | async)?.length > 1) {
                <va-breadcrumbs [breadcrumbs]="breadcrumbs$ | async" />
              }
              @if (breadcrumbs$ | async; as breadcrumbs) {
                <div>
                  @if (breadcrumbs?.length < 2) {
                    <span>
                      {{ breadcrumbs[breadcrumbs.length - 1]?.text | translate }}
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        @if (!mobile) {
          <div>
            @if (isSearchable$ | async) {
              <mat-form-field
                [floatLabel]="'auto'"
                class="mat-form-field"
                [ngClass]="{ 'active-search': searchActive }"
                >
                <input
                  matInput
                  #search
                  placeholder="{{ 'COMMON.ACTION_LABELS.SEARCH' | translate }}"
                  (keyup)="updateSearch(search.value)"
                  [value]="search$ | async"
                  />
                <mat-icon matPrefix>search</mat-icon>
                @if (search.value) {
                  <button
                    mat-button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="search.value = ''; updateSearch('')"
                    >
                    <mat-icon class="close">close</mat-icon>
                  </button>
                }
              </mat-form-field>
            }
            @if (primaryActionButton$ | async; as primaryActionButton) {
              @if (primaryActionButton.link) {
                <a
                  mat-button
                  color="primary"
                  class="hide-xs"
                  class="action-button"
                  [href]="primaryActionButton.link"
                  [target]="primaryActionButton.target ?? '_self'"
                  (click)="primaryActionClicked.emit(primaryActionButton)"
                  >
                  @if (primaryActionButton.icon) {
                    <mat-icon>
                      {{ primaryActionButton.icon }}
                    </mat-icon>
                  }
                  @if (primaryActionButton.svgIcon) {
                    <mat-icon [svgIcon]="primaryActionButton.svgIcon" />
                  }
                  {{ primaryActionButton.label | translate }}
                </a>
              }
              @if (!primaryActionButton.link && primaryActionButton.handler) {
                <button
                  mat-button
                  color="primary"
                  class="action-button hide-xs"
                  (click)="primaryActionButton.handler()"
                  (click)="primaryActionClicked.emit(primaryActionButton)"
                  >
                  @if (primaryActionButton.icon) {
                    <mat-icon>
                      {{ primaryActionButton.icon }}
                    </mat-icon>
                  }
                  @if (primaryActionButton.svgIcon) {
                    <mat-icon [svgIcon]="primaryActionButton.svgIcon" />
                  }
                  {{ primaryActionButton.label | translate }}
                </button>
              }
            }
            @if (secondaryActionButton$ | async; as secondaryActionButton) {
              @if (secondaryActionButton.link) {
                <a
                  mat-button
                  color="primary"
                  class="action-button hide-xs"
                  [href]="secondaryActionButton.link"
                  (click)="secondaryActionClicked.emit(secondaryActionButton)"
                  >
                  @if (secondaryActionButton.icon) {
                    <mat-icon>
                      {{ secondaryActionButton.icon }}
                    </mat-icon>
                  }
                  @if (secondaryActionButton.svgIcon) {
                    <mat-icon [svgIcon]="secondaryActionButton.svgIcon" />
                  }
                  {{ secondaryActionButton.label | translate }}
                </a>
              }
              @if (!secondaryActionButton.link && secondaryActionButton.handler) {
                <button
                  mat-button
                  color="primary"
                  class="action-button hide-xs"
                  (click)="secondaryActionButton.handler()"
                  (click)="secondaryActionClicked.emit(secondaryActionButton)"
                  >
                  @if (secondaryActionButton.icon) {
                    <mat-icon>
                      {{ secondaryActionButton.icon }}
                    </mat-icon>
                  }
                  @if (secondaryActionButton.svgIcon) {
                    <mat-icon [svgIcon]="secondaryActionButton.svgIcon" />
                  }
                  {{ secondaryActionButton.label | translate }}
                </button>
              }
            }
            @if (showInfoIcon$ | async) {
              <button
                mat-icon-button
                (click)="toggleSidebarInfo()"
                class="filter-icon"
                [ngClass]="{ open: sidebar.opened && this.sidebarView === 'info' }"
                >
                <mat-icon>help_outline</mat-icon>
              </button>
            }
            @if (sidebarFilters$ | async) {
              <button
                mat-icon-button
                (click)="toggleSidebarFilters()"
                class="filter-icon"
                [ngClass]="{ open: sidebar.opened && this.sidebarView === 'filters' }"
                >
                <mat-icon>filter_list</mat-icon>
              </button>
            }
          </div>
        }
      </mat-toolbar>
    }
    @if (mobile) {
      <uikit-mobile-action-bar
        [isSearchable]="isSearchable$ | async"
        [searchValue]="searchValue"
        [searchActive]="searchActive"
        [primaryActionButton]="primaryActionButton$ | async"
        [secondaryActionButton]="secondaryActionButton$ | async"
        [showInfoIcon]="showInfoIcon$ | async"
        [sidebarFilters]="sidebarFilters$ | async"
        (updateSearch)="updateSearch($event)"
        (infoIconClick)="toggleSidebarInfo()"
        (toggleSidebarClick)="toggleSidebarFilters()"
        />
    }
    <div
      class="content-wrapper"
      (scroll)="onScroll($event)"
      [ngClass]="{
        mobile:
          mobile &&
          ((isSearchable$ | async) ||
            (primaryActionButton$ | async) ||
            (secondaryActionButton$ | async) ||
            (showInfoIcon$ | async) ||
            (sidebarFilters$ | async)),
        'full-screen-content': hideToolbar,
      }"
      >
      <div class="content" [ngClass]="{ 'full-screen-content': hideToolbar }">
        <ng-content />
      </div>
    </div>
  </mat-sidenav-content>
  <mat-sidenav
    [style.visible]="sidebar ? 'visible' : 'hidden'"
    [mode]="mobile ? 'over' : 'side'"
    position="end"
    class="sidebar"
    [ngClass]="{ mobile: mobile, 'with-top-gap': topNavEnabled }"
    [fixedInViewport]="true"
    #sidebar
    >
    @if ((sidebarFilters$ | async) && this.sidebarView === 'filters') {
      <va-filter
        [filters]="sidebarFilters$ | async"
        (swiperight)="toggleSidebarFilters()"
        />
    }
    @if ((sidebarInfo$ | async)?.length > 0 && this.sidebarView === 'info') {
      <div
        class="sidebar-information"
        (swiperight)="toggleSidebarInfo()"
        >
        @for (infoSection of sidebarInfo$ | async; track infoSection) {
          @if (infoSection.title) {
            <h2>{{ infoSection.title | translate }}</h2>
          }
          @if (infoSection.secondaryTitle) {
            <h3>
              {{ infoSection.secondaryTitle | translate }}
            </h3>
          }
          @if (infoSection.descriptionParagraphs) {
            @for (para of infoSection.descriptionParagraphs; track para) {
              <p>
                <span [innerHTML]="para | translate"></span>
              </p>
            }
          }
          @for (bullet of infoSection.bulletPoints; track bullet) {
            <ul>
              <li>{{ bullet | translate }}</li>
            </ul>
          }
        }
      </div>
    }
  </mat-sidenav>
</mat-sidenav-container>
